var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("退款管理")]),_vm._v(" "),_c('section',{staticClass:"mainPart"},[_c('RefundInfo',{key:_vm.refreshnum,attrs:{"refundType":0,"enterWay":1,"eleType":"发货"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2326a6c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DeliveryFolder/RefundVerifyList.vue
// module id = null
// module chunks = 